module.exports = __webpack_public_path__ + "static/media/Kina4.af645dd1.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kina4.JPG
// module id = 268
// module chunks = 0